var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "defenseSession" }, [
    _c("div", { staticClass: "cont-box" }, [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c("Title", { attrs: { text: "毕业答辩" } }),
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "search",
                  staticClass: "search-form",
                  attrs: {
                    slot: "search",
                    inline: true,
                    model: _vm.condition,
                    rules: _vm.searchRules,
                    "label-width": "80px",
                  },
                  slot: "search",
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c("div", [
                        _c(
                          "div",
                          [
                            _c(
                              "el-form-item",
                              { attrs: { prop: "paper_plan_student_id" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "300px" },
                                    attrs: {
                                      placeholder: "请选择论文计划",
                                      clearable: "",
                                      filterable: "",
                                    },
                                    model: {
                                      value:
                                        _vm.condition.paper_plan_student_id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.condition,
                                          "paper_plan_student_id",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "condition.paper_plan_student_id",
                                    },
                                  },
                                  _vm._l(_vm.thesisPlanList, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.title,
                                        value: item.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.loadData },
                                  },
                                  [_vm._v("确认")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.list,
                headerRowClassName: "uni-primary-table-header",
                stripe: "",
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "plan_title", align: "center", label: "计划" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "defense_start_at",
                  align: "center",
                  label: "答辩开始时间",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "defense_address",
                  align: "center",
                  label: "答辩地点",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "group_title",
                  align: "center",
                  label: "答辩组",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "reply_teacher_titles",
                  align: "center",
                  label: "答辩组教师",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "defence_sort",
                  align: "center",
                  label: "答辩序号",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "process_status_title",
                  align: "center",
                  label: "状态",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }